module.exports = "/_next/static/images/4d24eac0aca313acb1bc4001bf8595c6-ticket-02-03.png";